import { useSelector } from 'react-redux';
import {
	workshopModuleTagGroupActions,
	workshopModuleTagGroupApi,
	workshopModuleTagGroupSlice,
} from '../../../../../../entities/module/tag-group/workshop-module-tag-group';
import { notificationError } from '../../../../../../components/Notifications/callNotifcation';
import { useAppDispatch } from '../../../../../../shared/libs/redux';
import { workshopModuleTagApi } from '../../../../../../entities/module/workshop-module-tag';

export const useBindWorkshopTagToGroup = () => {
	const dispatch = useAppDispatch();

	const [bind, requestData] = workshopModuleTagGroupApi.useBindMutation();

	const tags = useSelector(workshopModuleTagGroupSlice.selectors.getBindingTags);
	const groupId = useSelector(workshopModuleTagGroupSlice.selectors.getBindingGroupId);

	const bindTags = async () => {
		try {
			if (tags.length && groupId) {
				await bind({ groupId, tags }).unwrap();

				dispatch(workshopModuleTagGroupActions.setIsBindingGroupModalActive(false));
				dispatch(workshopModuleTagGroupActions.setBindingTags([]));

				// Принудительный рефетч для API, где хранятся теги:
				dispatch(workshopModuleTagApi.util.invalidateTags(['workshopTag']));
			}
		} catch (e) {
			notificationError('Произошла ошибка при привязке тегов к группе!');
		}
	};

	return { requestData, bindTags };
};
